import AdminLayout from '../../components/feature/AdminLayout';
import PaymentsTable from './components/PaymentsTable';

export default function PaymentsPage() {
  return (
    <AdminLayout>
      <PaymentsTable />
    </AdminLayout>
  );
}
